import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import useTranslation from 'next-translate/useTranslation';
import { TescomaClubIcon } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';
import { ProductPriceType } from 'types/price';

const ProductPrice: FC<ProductPriceType> = (productPrice) => {
    const testIdentifier = 'blocks-product-price';

    const { t } = useTranslation();
    const { formatPriceObject: formatPrice, formatPriceObjectForSR } = useFormatPrice();

    if (productPrice.isOldPrice) {
        return (
            <div
                aria-label={formatPriceObjectForSR(productPrice)}
                className="mb-1 text-small font-bold leading-4 text-red line-through"
            >
                <span className="text-primary" data-testid={testIdentifier}>
                    {formatPrice(productPrice)}
                </span>
            </div>
        );
    }

    if (productPrice.isTescomaPrice) {
        return (
            <div
                aria-label={t('For members') + '\u00A0' + formatPriceObjectForSR(productPrice)}
                className="mb-1 text-small font-bold leading-4 text-red"
                data-testid={testIdentifier}
            >
                {t('For members') + '\u00A0' + formatPrice(productPrice) + '\u00A0'}
                <TescomaClubIcon className="h-4 w-4 -translate-y-[2px]" />
            </div>
        );
    }

    return (
        <span
            aria-label={formatPriceObjectForSR(productPrice)}
            className={twJoin('text-h5 font-bold leading-4', productPrice.isActionPrice ? 'text-red' : 'text-primary')}
            data-testid={testIdentifier}
        >
            {formatPrice(productPrice)}
        </span>
    );
};

export default ProductPrice;
